import { createSlice } from "@reduxjs/toolkit";
import { doSendOtp, doVerifyOtp, doLogout } from "./auth.service";

const initialState = {
  accessToken: null,
  isAuthenticated: false,
  isAuthenticating: false,
  statusText: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    removeAccessToken: (state, action) => {
      state.accessToken = null;
      state.isAuthenticated = false;
      state.isAuthenticating = false;
      state.statusText = null;
    },
  },
  extraReducers: (builder) => {
    // Handling send otp action
    builder.addCase(doSendOtp.pending, (state, action) => {
      state.isAuthenticated = false;
      state.isAuthenticating = true;
      state.statusText = "Sending OTP";
    });
    builder.addCase(doSendOtp.fulfilled, (state, action) => {
      state.isAuthenticated = false;
      state.isAuthenticating = true;
      state.statusText = "OTP sent successfully";
    });
    builder.addCase(doSendOtp.rejected, (state, action) => {
      state.isAuthenticated = false;
      state.isAuthenticating = false;
      state.statusText = "Error sending OTP";
    });

    // Handling verify otp action
    builder.addCase(doVerifyOtp.pending, (state, action) => {
      state.isAuthenticated = false;
      state.isAuthenticating = true;
      state.statusText = "Verifying OTP";
    });
    builder.addCase(doVerifyOtp.fulfilled, (state, action) => {
      state.isAuthenticated = true;
      state.isAuthenticating = false;
      state.statusText = "OTP successfully verified";
      state.accessToken = action.payload.accessToken;
    });
    builder.addCase(doVerifyOtp.rejected, (state, action) => {
      state.isAuthenticated = false;
      state.isAuthenticating = false;
      state.statusText = "Error verifying OTP";
    });

    // Handling logout action
    builder.addCase(doLogout.pending, (state, action) => {
      state.statusText = "Logging out user";
    });
    builder.addCase(doLogout.fulfilled, (state, action) => {
      state.isAuthenticated = false;
      state.isAuthenticating = false;
      state.statusText = "Successfully logged out";
      state.accessToken = null;
    });
    builder.addCase(doLogout.rejected, (state, action) => {
      state.statusText = "Error logging out";
    });
  },
});

export const { removeAccessToken } = authSlice.actions;
export default authSlice.reducer;
